export default __webpack_public_path__ + "static/media/kazakhstan.49caf71e.png";